import './style.scss';
import React from 'react';
// eslint-disable-next-line max-len
import T360BranchesMappingTableHeader from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360BranchesMapping/T360BranchesMappingTableHeader/T360BranchesMappingTableHeader';
// eslint-disable-next-line max-len
import T360BranchesMappingTableBody from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360BranchesMapping/T360BranchesMappingTableBody/T360BranchesMappingTableBody';

const BranchesMappingTable: React.FC = () => {
  return (
    <div className="d-flex flex-column flex-grow-1 pt-4 t360-branches-mapping-table">
      <>
        <T360BranchesMappingTableHeader />
        <T360BranchesMappingTableBody />
      </>
    </div>
  );
};

export default BranchesMappingTable;
